export default __webpack_public_path__ + "static/media/aws-cloudformation.4c9729aa.svg";